import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBinIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		opacity: .5,
		cx: 10,
		cy: 10,
		r: 10,
		fill: "#D3E1F0"
	}), /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.66406 7.49998H13.3307V13C13.3307 14.1046 12.4353 15 11.3307 15H8.66406C7.55949 15 6.66406 14.1046 6.66406 13V7.49998Z",
				stroke: "#003764",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.41406 7.49998L14.5807 7.49998",
				stroke: "#003764",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.33203 5.41666L11.6654 5.41666",
				stroke: "#003764",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.74609 9.16666L8.74609 13.3333",
				stroke: "#003764",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2461 9.16666L11.2461 13.3333",
				stroke: "#003764",
				strokeWidth: 1.5
			})
		]
	})]
});
export default SvgBinIcon;
